export default {
      id: "crossed-eye-icon-usage",
      viewBox: "0 0 16 13",
      url: __webpack_public_path__ + "sprite.svg#crossed-eye-icon-usage",
      toString: function () {
        return this.url;
      }
    }